/**
 * Full Focus Sessions registration embed (FR-REG-01).
 *
 *   <script src="https://sessions.fullfocus.co/embed.js" async></script>
 *   <div data-ffs-form="FORM_PUBLIC_ID" data-button-text="Save my seat"></div>
 *
 * Built as a classic IIFE: `scriptBase` must be read synchronously here (document.currentScript),
 * which the `./lib/base` module import does. Exposes `window.FFSEmbed.mount()` for page builders.
 */
import { mountAll, start } from './mount';

export { mountAll as mount };
export const version = '0.1.0';

start();
